/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Features_Upcomingreleases1Inputs */

const id_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat rilis mendatang dan promosi game gratis`)
};

const ms_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat keluaran akan datang dan promosi permainan percuma`)
};

const da_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se kommende udgivelser og gratis spil-kampagner`)
};

const de_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehen Sie sich bevorstehende Veröffentlichungen und Gratisspiel-Aktionen an`)
};

const en_us2_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View upcoming releases and free game promotions`)
};

const es_es2_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta próximos lanzamientos y promociones de juegos gratis`)
};

const es_mx2_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta próximos lanzamientos y promociones de juegos gratis`)
};

const fil_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingnan ang mga paparating na release at libreng game promotions`)
};

const fr_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulter les sorties à venir et les promotions de jeux gratuits`)
};

const it_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza le prossime uscite e le promozioni di giochi gratuiti`)
};

const hu_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közelgő megjelenések és ingyenes játék promóciók megtekintése`)
};

const nl_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk aankomende releases en gratis game-promoties`)
};

const no_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se kommende utgivelser og gratisspillkampanjer`)
};

const pl_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeglądaj nadchodzące premiery i promocje darmowych gier`)
};

const pt_br2_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja os próximos lançamentos e promoções de jogos gratuitos`)
};

const pt_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja próximos lançamentos e promoções de jogos grátis`)
};

const ro_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezi lansările viitoare și promoțiile cu jocuri gratuite`)
};

const fi_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä tulevat julkaisut ja ilmaispelitarjoukset`)
};

const sv_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa kommande släpp och gratisspelkampanjer`)
};

const vi_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem các bản phát hành sắp tới và khuyến mãi game miễn phí`)
};

const tr_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaklaşan çıkışları ve ücretsiz oyun promosyonlarını görüntüleyin`)
};

const cs_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohlížejte nadcházející vydání a promoakce her zdarma`)
};

const bg_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преглеждайте предстоящи издания и промоции за безплатни игри`)
};

const ru_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просматривайте предстоящие релизы и акции с бесплатными играми`)
};

const uk_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переглядайте майбутні релізи та безкоштовні акції`)
};

const ar_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض الإصدارات القادمة وعروض الألعاب المجانية`)
};

const hi_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगामी रिलीज़ और मुफ़्त गेम प्रचार देखें`)
};

const th_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูการวางจำหน่ายที่กำลังจะมาและโปรโมชันเกมฟรี`)
};

const ja_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今後のリリースと無料ゲームキャンペーンを表示`)
};

const zh_cn2_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看即将发布的游戏和免费游戏赠送活动`)
};

const zh_hant1_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檢視即將發布的遊戲和免費遊戲贈送活動`)
};

const ko_privacy_features_upcomingreleases1 = /** @type {(inputs: Privacy_Features_Upcomingreleases1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출시 예정작 및 무료 게임 프로모션 확인`)
};

/**
* | output |
* | --- |
* | "View upcoming releases and free game promotions" |
*
* @param {Privacy_Features_Upcomingreleases1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_features_upcomingreleases1 = /** @type {((inputs?: Privacy_Features_Upcomingreleases1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Features_Upcomingreleases1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_features_upcomingreleases1(inputs)
	if (locale === "ms") return ms_privacy_features_upcomingreleases1(inputs)
	if (locale === "da") return da_privacy_features_upcomingreleases1(inputs)
	if (locale === "de") return de_privacy_features_upcomingreleases1(inputs)
	if (locale === "en-US") return en_us2_privacy_features_upcomingreleases1(inputs)
	if (locale === "es-ES") return es_es2_privacy_features_upcomingreleases1(inputs)
	if (locale === "es-MX") return es_mx2_privacy_features_upcomingreleases1(inputs)
	if (locale === "fil") return fil_privacy_features_upcomingreleases1(inputs)
	if (locale === "fr") return fr_privacy_features_upcomingreleases1(inputs)
	if (locale === "it") return it_privacy_features_upcomingreleases1(inputs)
	if (locale === "hu") return hu_privacy_features_upcomingreleases1(inputs)
	if (locale === "nl") return nl_privacy_features_upcomingreleases1(inputs)
	if (locale === "no") return no_privacy_features_upcomingreleases1(inputs)
	if (locale === "pl") return pl_privacy_features_upcomingreleases1(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_features_upcomingreleases1(inputs)
	if (locale === "pt") return pt_privacy_features_upcomingreleases1(inputs)
	if (locale === "ro") return ro_privacy_features_upcomingreleases1(inputs)
	if (locale === "fi") return fi_privacy_features_upcomingreleases1(inputs)
	if (locale === "sv") return sv_privacy_features_upcomingreleases1(inputs)
	if (locale === "vi") return vi_privacy_features_upcomingreleases1(inputs)
	if (locale === "tr") return tr_privacy_features_upcomingreleases1(inputs)
	if (locale === "cs") return cs_privacy_features_upcomingreleases1(inputs)
	if (locale === "bg") return bg_privacy_features_upcomingreleases1(inputs)
	if (locale === "ru") return ru_privacy_features_upcomingreleases1(inputs)
	if (locale === "uk") return uk_privacy_features_upcomingreleases1(inputs)
	if (locale === "ar") return ar_privacy_features_upcomingreleases1(inputs)
	if (locale === "hi") return hi_privacy_features_upcomingreleases1(inputs)
	if (locale === "th") return th_privacy_features_upcomingreleases1(inputs)
	if (locale === "ja") return ja_privacy_features_upcomingreleases1(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_features_upcomingreleases1(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_features_upcomingreleases1(inputs)
	return ko_privacy_features_upcomingreleases1(inputs)
});
export { privacy_features_upcomingreleases1 as "privacy.features.upcomingReleases" }